export { };
export const defaults = {
	app: {
		applicationId: 'advertisingconsent',
		pageEditorClass: 'is-page-editor',
		generalErrorCodes: [
			{ code: '116000', message: 'Es trat ein Fehler beim Zugriff auf das Bestandssystem auf' }
		],
		validatorRules: {
			rules: {
				Mitgliedsnummer: {
					required: true,
					minlength: 9,
					maxlength: 9,
					number: true,
					membernumbercheck: true,
					membernumberwithvescheck: true
				},
				Vorname: {
					required: true,
					maxlength: 40,
					nonumber: true
				},
				Nachname: {
					required: true,
					maxlength: 40,
					nonumber: true
				},
				StrasseHausnummer: {
					required: true,
					minlength: 2,
					maxlength: 30,
					streetandnumber: true
				},
				Postleitzahl: {
					required: true,
					minlength: 5,
					maxlength: 5,
					number: true
				},
				Ort: {
					required: true,
					maxlength: 30
				},
				Email: {
					email: true,
					required: true
				},
				TelefonNummer: {
					maxlength: 16,
					required: true
				},
				TelefonGeschaeftlichNummer: {
					maxlength: 16,
					required: true
				},
				"Antragssteller.Datenverwendung.Einwilligung": {
					required: true,
					oneoptinrequired: true
				}
			}
		},
		validationmessages: {
			client: {
				Mitgliedsnummer: {
					required: "Sie haben keine Mitglieds-/Kundennummer eingegeben. Bitte korrigieren Sie ihre Eingabe!",
					minlength: "Bitte {0} Zahlen angeben.",
					maxlength: "Bitte {0} Zahlen angeben.",
					number: "Bitte geben Sie nur Zahlen für die Mitglieds-/Kundennummer an.",
					membernumbercheck: "Bitte geben Sie eine gültige Mitglieds-/Kundennummer an.",
					membernumberwithvescheck: "Bitte geben Sie eine gültige Mitglieds-/Kundennummer an.",
				},
				Vorname: {
					maxlength: "Bitte maximal {0} Buchstaben",
					required: "Sie haben keinen Vornamen eingegeben. Bitte korrigieren Sie Ihre Angabe.",
					nonumber: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Angabe."
				},
				Nachname: {
					maxlength: "Bitte maximal {0} Buchstaben",
					required: "Sie haben keinen Nachname angegeben. Bitte korrigieren Sie ihre Angabe!",
					nonumber: "Bitte geben Sie für den Nachname keine Zahlen an."
				},
				StrasseHausnummer: {
					required: "Bitte geben Sie den Straßennamen und die Hausnummer an.",
					minlength: "Bitte geben Sie mindestens {0} Zeichen an.",
					maxlength: "Bitte geben Sie maximal {0} Zeichen an.",
					streetandnumber: "Bitte korrigieren Sie Ihre Angabe. Erlaubt sind folgende Sonderzeichen: .,-/’"
				},
				Postleitzahl: {
					maxlength: "Bitte {0} Zahlen angeben.",
					minlength: "Bitte {0} Zahlen angeben.",
					required: "Bitte geben Sie eine Postleitzahl an. ",
					number: "Bitte nur Zahlen angeben."
				},
				Ort: {
					maxlength: "Bitte maximal {0} Zeichen angeben.",
					required: "Bitte geben Sie die gültige Postleitzahl und den Wohnort ein.",
				},
				Email: {
					email: "Die E-Mail-Adresse ist nicht gültig!",
					required: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!"
				},
				TelefonNummer: {
					inputcross: "Bitte Vorwahl und Rufnummer angeben.",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen",
					required: "Bitte Vorwahl und Rufnummer angeben."
				},
				TelefonGeschaeftlichNummer: {
					inputcross: "Bitte Vorwahl und Rufnummers angeben.",
					pattern: "Dieses Feld muss korrekt gefüllt sein! Bitte prüfen Sie Ihre Eingabe!",
					maxlength: "Bitte maximal {0} Zahlen",
					required: "Bitte Vorwahl und Rufnummer angeben."
				},
				"Antragssteller.Datenverwendung.Einwilligung": {
					required: "Bitte wählen Sie diese Option.",
					oneoptinrequired: "Bitte wählen Sie mindestens eine Option."
				}
			},
			backend: {}
		}
	}
};